import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Organization } from 'services/api';
import type { OrganizationsState } from './types';
import { getOrganizationsListAction } from './actions';

const initialState: OrganizationsState = {
  organizations: [],
  total: 0,
  selectedOrganization: null,
  loading: false,
};

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    setSelectedOrganization: (state, action: PayloadAction<Organization>) => {
      state.selectedOrganization = action.payload;
    },
    clearSelectedOrganization: (state) => {
      state.selectedOrganization = null;
    },
    clearState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    // Get organizations list
    builder.addCase(getOrganizationsListAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOrganizationsListAction.fulfilled, (state, action) => {
      state.loading = false;
      state.organizations = action.payload.content;
      state.total = action.payload.totalElements;
    });
    builder.addCase(getOrganizationsListAction.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const organizationsReducer = organizationsSlice.reducer;
export const { setSelectedOrganization, clearSelectedOrganization, clearState } =
  organizationsSlice.actions;
